import { useFetchBanners } from "@/apis/queryFunctions/banner";
import appendImageUrlFromAPI from "@/utils/appendImageUrlFromAPI";
import { getHrefLinkOfBanner } from "@/utils/getHrefLinkOfBanner";
import Slider from "@ant-design/react-slick";
import { Box, createStyles, Skeleton } from "@mantine/core";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { NextArrow, PrevArrow } from "./SliderArrows";

const useStyles = createStyles((theme) => ({
  container: {
    width: "100%",
    maxHeight: "calc(100vh - 100px)",
    // aspectRatio: "2.44",

    position: "relative",
    transition: "0.3s",
  },
  sliderItem: {
    width: "100%",
    maxHeight: "calc(100vh - 100px)",
    // aspectRatio: "2.27",
    // aspectRatio: "2.44",
    transition: "0.3s",

    position: "relative",
  },
  dotsClass: {
    position: "absolute",
    bottom: "10px",
    width: "100%",
    listStyle: "none",
    textAlign: "center",
    padding: 0,
    margin: 0,

    // "& li button:before": {
    //   fontSize: "10px !important",
    // },
    // "& li.slick-active button:before": {
    //   color: "#EBBC1D",
    // },

    "& li": {
      position: "relative",
      display: "inline-block",
      width: "20px",
      height: "20px",
      margin: "0 5px",
      padding: "0",
      cursor: "pointer",
    },

    "& li button": {
      fontSize: 0,
      lineHeight: 0,
      display: "block",
      width: "20px",
      height: "20px",
      padding: "5px",
      cursor: "pointer",
      color: "transparent",
      border: 0,
      outline: "none",
      background: "transparent",
    },

    "& li button:after": {
      // content: "'⚫'",
      fontFamily: "slick",
      fontSize: "10px",
      lineHeight: "20px",
      position: "absolute",
      top: 0,
      left: 0,
      width: "20px",
      height: "20px",
      content: "'•'",
      textAlign: "center",
      opacity: 0.25,
      color: theme.colors.second[0],
      // "-webkit-font-smoothing": "antialiased",
    },
    "& li.slick-active button:after": {
      opacity: ".75",
      color: "#EBBC1D",
    },
  },
}));

export default function BannerTop({ position, aspectRatio }) {
  const { classes } = useStyles();
  const { data: sliders } = useFetchBanners({
    condition: {
      vi_tri: position,
      shared: true,
    },
    sort: {
      sst: 1,
    },
  });

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    // appendDots: (dots) => <ul className={classes.dotsClass}>{dots}</ul>,
    dotsClass: classes.dotsClass,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <Skeleton visible={!sliders}>
      <div
        className={classes.container}
        id="banners"
        style={{ aspectRatio: `${aspectRatio} !important`, width: "100%" }}
      >
        <Slider {...settings}>
          {sliders &&
            sliders.map((item) => (
              <Link
                href={getHrefLinkOfBanner(item)}
                scroll={false}
                key={item._id}
              >
                <a>
                  <Box
                    className={classes.sliderItem}
                    sx={{ aspectRatio: `${aspectRatio} !important` }}
                  >
                    <Image
                      src={appendImageUrlFromAPI({
                        src: item.hinh_anh,
                        size: "xl",
                      })}
                      alt="a"
                      layout="fill"
                      priority
                      quality={100}
                    />
                  </Box>
                </a>
              </Link>
            ))}
          {/* if (item?.url_banner) {
						return <Link>
						</Link>
					} else {
						return <div className={classes.sliderItem}>
							<Image src={logo} alt="a" layout="fill" />
						</div>
					} */}
        </Slider>
      </div>
    </Skeleton>
  );
}
